import ActionTypes from "./action.types";
const Actions = {
    setUser: (user) => ({
        type: ActionTypes.SET_USER,
        payload: {
            user
        }
    }),
    addUser: (user) => ({
        type: ActionTypes.ADD_USER,
        payload: {
            user
        }
    }),
    setPackageType: (packageType) => ({
        type: ActionTypes.SET_PACKAGE_TYPE,
        payload: {
            packageType
        }
    }),
    setUsageType: (usageType) => ({
        type: ActionTypes.SET_USAGE_TYPE,
        payload: {
            usageType
        }
    }),

    setStats: (stats) => ({
        type: ActionTypes.SET_STATS,
        payload: {
            stats
        }
    }),

    updateBlockedEmail: (blocked) => ({
        type: ActionTypes.UPDATE_BLOCKED_EMAIL,
        payload: {
            blocked
        }
    }),

    updatePhishingUrl: (phishingUrl) => ({
        type: ActionTypes.UPDATE_PHISHING_URL,
        payload: {
            phishingUrl
        }
    }),


    setPhishingUrls: (phishingUrls) => ({
        type: ActionTypes.SET_PHISHING_URLS,
        payload: {
            phishingUrls
        }
    }),


    setBlockedEmails: (blockedEmails) => ({
        type: ActionTypes.SET_BLOCKED_EMAILS,
        payload: {
            blockedEmails
        }
    }),
    setCoupon: (coupon) => ({
        type: ActionTypes.SET_COUPON,
        payload: {
            coupon
        }
    }),

    setSignupError: (signupError) => ({
        type: ActionTypes.SET_SIGNUP_ERROR,
        payload: {
            signupError
        }
    }),
    setSelectedUser: (user) => ({
        type: ActionTypes.SET_SELECTED_USER,
        payload: {
            user
        }
    }),
    setSignupStep: (step) => ({
        type: ActionTypes.SET_SIGNUP_STEP,
        payload: {
            step
        }
    }),
    setFileNames: (filenames) => ({
        type: ActionTypes.SET_FILENAMES,
        payload: {
            filenames
        }
    }),
    updateAccount: (account) => ({
        type: ActionTypes.UPDATE_ACCOUNT,
        payload: {
            account
        }
    }),
    setAccounts: (accounts) => ({
        type: ActionTypes.SET_ACCOUNTS,
        payload: {
            accounts
        }
    }),

    setToast: (header, msg) => ({
        type: ActionTypes.SET_TOAST,
        payload: {
            header,
            msg
        }
    }),
    clearToast: () => ({
        type: ActionTypes.CLEAR_TOAST
    })

}


export default Actions;